<script>
import CodeBlock from '@/components/shared/CodeBlock.vue';
import Note from '@/components/shared/Note.vue';
import ApiSubSection from './subSection/SubSection.vue';

export default {
  name: 'ApiTab',

  components: {
    CodeBlock,
    Note,
    ApiSubSection,
  },

  props: {
    tab: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<template>
  <div class="tab">
    <div class="column">
      <ApiSubSection v-for="row in tab.fields.subsections" :key="row.sys.id" :data="row.fields" />
    </div>

    <div class="column sticky">
      <Note v-if="tab.fields.note" :content="tab.fields.note.fields" />

      <CodeBlock
        v-if="tab.fields.request"
        :content="tab.fields.request.fields"
        :is-api-data="true"
      />

      <CodeBlock
        v-if="tab.fields.response"
        :content="tab.fields.response.fields"
        :is-api-data="true"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@include desktop-medium {
  .tab {
    display: flex;
    align-self: start;

    .column {
      width: 50%;
    }
  }
}

.sticky {
  position: sticky;
  top: $topbar-height-large;
  height: 100%;

  .code-block,
  .note {
    margin: 0 0 $space-24 0;
  }

  @include desktop-medium {
    padding-left: $space-40;
    padding-bottom: $space-16;

    .code-block,
    .note {
      margin: $space-24 0;
    }
  }
}
</style>
